import { useState, useEffect } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 200,
            overflowX: 'auto'
        },
    },
};

function MultipleSelectCheckmarks({
    title,
    options = [],
    value = [],
    onChange,
    isLoading,
    displayFormat,
    valueKey = 'id',
    isRequired,
    clearDropdown
}) {
    const [selectedOptions, setSelectedOptions] = useState(value);

    useEffect(() => {
        if (clearDropdown) {
            setSelectedOptions([]);
        }
    }, [clearDropdown]);

    const handleChange = (event) => {
        const { value } = event.target;

        let newSelectedOptions;

        if (value.includes('all')) {
            newSelectedOptions =
                selectedOptions.length === options.length ? [] : options;
        } else {
            newSelectedOptions = value;
        }

        setSelectedOptions(newSelectedOptions);
        const selectedValues = newSelectedOptions.map((item) => ({
            [valueKey]: item[valueKey],
        }));

        onChange?.(selectedValues);
    };

    const isAllSelected = selectedOptions.length === options.length;

    return (
        <FormControl sx={{ m: 1, minWidth: 200 }} required={isRequired}>
            <InputLabel>{title}</InputLabel>

            <Select
                multiple
                value={selectedOptions}
                onChange={handleChange}
                input={<OutlinedInput label={title} />}
                renderValue={(selected) =>
                    selected.map(displayFormat).join(', ')
                }
                MenuProps={MenuProps}
                disabled={isLoading}
            >
                <MenuItem value="all">
                    <Checkbox checked={isAllSelected} />
                    <ListItemText primary="All" />
                </MenuItem>

                {options.map((option, index) => (
                    <MenuItem key={option[valueKey] || index} value={option}>
                        <Checkbox checked={selectedOptions.includes(option)} />
                        <ListItemText primary={displayFormat(option)} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}


export default MultipleSelectCheckmarks;


